<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>장비점검계획</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-8" >
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">닫기</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" @click="handleClickRegister">임시저장</vs-button>
      </div>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">사무소명</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" :value="projectInfo.field_name" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4">작성자</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.writer" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">근무기간</vs-col>
          <vs-col class="w-9/12">
            <vs-select autocomplete class="w-full" v-model="form.work_type">
              <vs-select-item text="근무구분1" value="workType1"/>
              <vs-select-item text="근무구분2" value="workType2"/>
              <vs-select-item text="근무구분3" value="workType3"/>
              <vs-select-item text="근무구분4" value="workType4"/>
              <vs-select-item text="근무구분5" value="workType5"/>
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4 ">소속</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.company" :readonly="true"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">제목</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.title"/></vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col class="flex mb-4">
          <h5><i class="dot"></i>점검계획</h5>
          <vs-spacer></vs-spacer>
          <a @click="handleClickAddPlan" style="color:#6670CB;">+ 항목추가</a>
          <span class="mx-4">|</span>
          <a @click="handleClickRemovePlan" style="color:#6670CB;">- 항목삭제</a>
        </vs-col>
        <vs-col class="flex" style="align-items: center;">
          <vs-col class="w-3/12 title">점검계획일</vs-col>
          <date-selector class="w-9/12" v-model="form.check_date"/>
        </vs-col>
      </vs-row>

      <vs-row class="border mb-0" style="width: auto; margin-left:-1.2rem; margin-right:-1.2rem;" v-for="(issue, index) in plan_list" :key="index">
        <vs-col class="flex" style="padding:12px 1.25rem; background-color: #fafafa; border-top:1px solid #cdcdcd; border-bottom:1px solid #cdcdcd;">
          <vs-checkbox v-model="issue.is_checked">선택</vs-checkbox>
          <vs-spacer></vs-spacer>
          <div style="display: flex; align-items: center; justify-content: center; padding:8px; transition: all .3s ease;"
               :style="issue.is_hidden ? '-webkit-transform: rotate(180deg);' : ''"
               @click="issue.is_hidden = !issue.is_hidden">
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.41 7.41016L6 2.83016L10.59 7.41016L12 6.00016L6 0.000156403L0 6.00016L1.41 7.41016Z" fill="black"/>
            </svg>
          </div>
        </vs-col>
        <vs-col style="padding: 12px 1.25rem 0px; transition: all .3s ease;" :style="issue.is_hidden ? 'height:0; opacity:0; overflow: hidden;' : ''">
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">구분</span>
            <span class="w-8/12">
              <vs-select autocomplete class="w-full mb-0" row="5" v-model="issue.type" >
                <vs-select-item text="굴삭기A" value="type_a"/>
                <vs-select-item text="굴삭기B" value="type_b"/>
                <vs-select-item text="굴삭기C" value="type_c"/>
              </vs-select>
            </span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">장비명</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="form.name" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">관리번호</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="form.control_num" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">모델명</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="form.model_name" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">제조사</span>
            <span class="w-8/12"><vs-textarea class="mb-0" row="5" v-model="form.manufacturer" :readonly="board.readonly"></vs-textarea></span>
          </vs-col>
          <vs-col class="flex mb-4 pb-4" style="align-items: center; border-bottom:1px solid #f4f4f4;">
            <span class="w-4/12">안전인증일/<br>인증기관</span>
            <span class="w-8/12" style=" display: grid;">
              <date-selector class="w-full mt-0 mb-2" v-model="form.inspection_date"/>
              <vs-input class="w-full mb-0" row="5" v-model="form.inspection_com" :readonly="board.readonly"></vs-input>
            </span>
          </vs-col>
          <vs-col class="flex mb-4 " style="align-items: center; ">
            <span class="w-4/12">안전-정기 검사일/<br>검사기관</span>
            <span class="w-8/12" style="display: grid;">
              <date-selector class="w-full mt-0 mb-2" v-model="form.check_date"/>
              <vs-input class="w-full mb-0" row="5" v-model="form.check_com" :readonly="board.readonly"></vs-input>
            </span>
          </vs-col>

        </vs-col>
      </vs-row>

      <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
        <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
          <vs-spacer @click="hideApproval"></vs-spacer>
          <approval-process-module
            :board="board"
            :commentabled="!(board.isCompleteApproval || board.savable)"

            @handleClickUpload="handleClickUpload"
            @handleSendApprovalProcess="handleSendApprovalProcess"
          ></approval-process-module>
          <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
          </a>
        </div>

      </vs-row>


    </div>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show" :message="alert.message" :buttons="alert.buttons" @upload="alertUpload"/>
  </div>
</template>

<script>
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import PopupAlert from '@/views/components/popup/PopupAlert'
import DateSelector from '@/views/components/DateSelector'
import PopupEquipmentResult from '@/views/project/popup/PopupEquipmentResult'
import VueCookie from 'vue-cookie'
import SafetyEquipmentPlanTableList from '@/views/project/safety/equipment/components/SafetyEquipmentPlanTableList'

export default {
  name: 'MobileSafetyEquipmentCheckCreate',
  components: {
    SafetyEquipmentPlanTableList,
    PopupEquipmentResult,
    DateSelector,
    PopupAlert,
    ApprovalProcessModule
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    }
  },
  data () {
    return {
      boardSlug: 'construction_equipment',

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: 'construction_equipment',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      // TODO : 얼럿데이터
      alert: {
        show: false,
        message: '결재하시겠습니까?',
        buttons: [
          {
            label: '승인',
            action: 'ok'
          },
          {
            label: '취소',
            action: 'cancel'
          }
        ]
      },
      planAllCheck: false,
      approvalLine: [], // 결재선 등록
      isShowApproval:false,

      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },
      popupActive: false,

      form: {
        project_title: '',
        title: '',
        writer: '',
        work_type:'',
        company: '',
        check_date:'',
        plan_list: [],
        preview: {
          project_title: '',
          title: '',
          work_type:'',
          check_date: '',
          move_date: '',
          result_date: '',
          plan_list: []
        }
      },
      plan_list: []
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true)
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true)
      }

    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },


  async created () {
    // 초기화
    this.form.check_date = VueCookie.get('equipment_create_selectday')
    await this.init()
  },

  methods: {
    back () {
      this.$router.back()
    },

    async init () {
      await this.$store.dispatch('USER_INFO')
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        company_name: this.$store.state.auth.userInfo.company_name
      }
      await this.$store.dispatch('company/LOAD_COMPANY', {companyId: this.board.writer.company_id})
      this.board.writer.company_name = this.$store.state.company.companyInfo.com_name
      this.form.writer = this.board.writer.name
      this.form.company = this.board.writer.company_name

      this.oldForm = JSON.parse(JSON.stringify(this.form))
    },
    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const title = this.form.title
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]

      this.form.plan_list = this.plan_list

      // 리스트 노출 정보
      this.form.project_title = this.projectInfo.field_name
      this.form.preview.project_title = this.form.project_title
      this.form.preview.title = this.form.title
      this.form.preview.work_type = this.form.work_type
      this.form.preview.check_date = this.form.check_date
      this.form.preview.move_date = this.form.move_date
      this.form.preview.result_date = this.form.result_date
      this.form.preview.plan_list = this.form.plan_list
      const content = JSON.stringify(this.form)

      try {
        if (this.formCheck()) {

          if (isUploaded) {
            // 바로 상신하기
            await this.$store.dispatch('approval/CREATE_POST', {
              projectId,
              boardSlug,
              title,
              content,
              approvalLine,
              security,
              priority
            })
            alert('상신되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          } else {
            // 임시 저장하기
            const isTemp = 1
            await this.$store.dispatch('approval/CREATE_POST', {
              projectId,
              boardSlug,
              title,
              content,
              approvalLine,
              security,
              priority,
              isTemp
            })
            alert('임시저장되었습니다.')
            this.oldForm = JSON.parse(JSON.stringify(this.form))
            this.back()
          }
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
        }
      }

    },

    formCheck () {
      if (this.form.work_type.trim().length <= 0) {
        alert('근무구분을 선택해주세요')
        return false
      } else if (this.form.title.trim().length <= 0) {
        alert('제목을 입력해주세요')
        return false
      }
      return true
    },

    // TODO : 얼럿데이터
    alertUpload () {
      this.register(true)
    },

    // TODO : 결재프로세스
    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id: member.user_id,
            name: member.user_name,
            elementType: member.type_code
          })
        }
      }

      return approvalList
    },

    handleClickClose () {
      this.back()
    },

    addPlan (name, size, quantity, unit_price, price, etc) {
      this.plan_list.push({
        is_hidden: false,
        is_checked: this.planAllCheck,
        name, // 품목명
        size, // 규격
        quantity, // 수량
        unit_price, // 단가
        price, // 금액
        etc // 비고
      })
    },
    addPlanEmpty () {
      this.addPlan('', '', '', '', '', '')
    },
    changePlanAllCheck () {
      for (const data of this.plan_list) {
        data.is_checked = this.orderAllCheck
      }
    },
    handleClickRegister () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },
    handleClickAddPlan () {
      this.addPlanEmpty()
    },

    handlePlanChangeChecked () {
      let count = 0
      for (const data of this.plan_list) {
        if (data.is_checked === true) {
          count++
        }
      }
      this.planAllCheck = (Number(count) === Number(this.plan_list.length))
    },
    handleClickRemovePlan () {
      for (let i = 0; i < this.plan_list.length; i++) {
        if (this.plan_list[i].is_checked) {
          this.plan_list.remove(this.plan_list[i])
          i = -1
        }
      }

      this.planAllCheck = false
    },

    handleClickResult () {
      this.popupActive = true
    },

    handleBackMenu () {
      this.$emit('handleBackMenu', 'plan')
    },

    popupActiveSync () {
      this.popupActive = false
    },

    handleClickUpload () {
      this.alert.buttons = [
        {
          label: '상신',
          action: 'upload'
        },
        {
          label: '취소',
          action: 'cancel',
          type: 'border'
        }
      ]
      this.alert.show = true
    },

    handleSendApprovalProcess (process) {
      this.approvalLine = process
    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    }
  }
}
</script>

<style scoped>
</style>
